// extracted by mini-css-extract-plugin
export default {"emptyStateDivBox":"emptyStateDivBox__ZYarg","melcloudListBody":"melcloudListBody__prF3Q"};